import styled from "styled-components";
import CloseButton from "@common/LifeAtButton/Buttons/CloseButton";
import { useAppearanceContext } from "@contexts/AppearanceContext";
import Animations from "@themes/Animations";
import breathingGifDark from "/resources/images/breathing-dark.gif";
import breathingGifLight from "/resources/images/breathing.gif";

const BreathingWidgetContainer = styled.div<{ lightMode: boolean }>`
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: ${({ lightMode }) => (lightMode ? "#FFF" : "#23282E")};
    z-index: 1000001;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    animation: ${Animations.fadeIn};
`;

const StyledCloseButton = styled(CloseButton)`
    position: absolute;
    top: 20px;
    right: 20px;
`;

const StyledBackgroundGif = styled.img`
    max-width: 60%;
    max-height: 60%;
`;

interface BreathingWidgetProps {
    readonly onClose: () => void;
}
export default function BreathingWidget({ onClose }: BreathingWidgetProps) {
    const { lightMode } = useAppearanceContext();
    const backgroundSrc = lightMode ? breathingGifLight : breathingGifDark;

    return (
        <BreathingWidgetContainer lightMode={lightMode}>
            <StyledCloseButton handleClose={onClose} />
            <StyledBackgroundGif src={backgroundSrc} />
        </BreathingWidgetContainer>
    );
}
